/* eslint-disable no-underscore-dangle */
export default (url, cid) => `${window.location.origin}/customer_switch/${cid}/?next=${url}`;
